<!--
 * @Author: your name
 * @Date: 2020-07-23 19:19:48
 * @LastEditTime: 2020-07-23 19:55:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/lib/ui/components/x-input/x-input.vue
-->
<template>
  <div class="x-area">
    <div class="x-area-mask" :class="{'x-area-mask-show': visiable}" @click="closePicker"></div>
    <cube-cascade-picker
      ref="xAreaPicker"
      :data="asyncData"
      :selected-index="asyncSelectedIndex.slice()"
      :title="''"
      :cancel-txt="'清空'"
      :mask-closable="false"
      :async="true"
      @select="selectHandle"
      @cancel="cancelHandle"
      @change="asyncChangeHandle">
    </cube-cascade-picker>
  </div>
  
</template>

<script>
import apis from '@/api'
export default {
  name: 'XArea',
  data() {
    return {
      value: '',
      asyncPicker: undefined,
      asyncData: [],
      asyncSelectedIndex: [0, 0, 0],
      provinceList: [],
      cityList: [],
      areaList: [],
      visiable: false
    }
  },
  mounted() {
    // this.asyncPicker = this.$createCascadePicker({
    //   title: '',
    //   async: true,
    //   data: this.asyncData,
    //   selectedIndex: this.asyncSelectedIndex.slice(),
    //   onSelect: this.selectHandle,
    //   onCancel: this.cancelHandle,
    //   onChange: this.asyncChangeHandle,
    //   swipeTime: 1000,
    //   cancelTxt: '清空',
    //   maskClosable: false
    // })
    this.asyncPicker = this.$refs.xAreaPicker
  },
  methods: {
    showAsyncPicker() {
      this.asyncPicker.show()
      this.visiable = true
      this.queryArea({}).then(
        (resp) => {
          this.provinceList = (resp.data || []).map(item => {
            return {
              text: item.name,
              value: item.province
            }
          })
          this.queryArea({
            province: this.provinceList[0].value
          }).then(
            (resp) => {
              this.cityList = (resp.data || []).map(item => {
                return {
                  text: item.name,
                  value: item.city
                }
              })
              this.queryArea({
                province: this.provinceList[0].value,
                city: this.cityList[0].value
              }).then(
                (resp) => {
                  this.areaList = (resp.data || []).map(item => {
                    return {
                      text: item.name,
                      value: item.city
                    }
                  })
                  this.asyncSelectedIndex = [0, 0, 0]
                  this.asyncData = this.provinceList.map(item => {
                    return {
                      ...item,
                      children: this.cityList.map(city => {
                        return {
                          ...city,
                          children: this.areaList
                        }
                      })
                    }
                  })
                  this.asyncPicker.setData(this.asyncData, this.asyncSelectedIndex)
                }
              )
            }
          )
        }
      )
    },
    asyncChangeHandle(i, newIndex) {
      if (newIndex !== this.asyncSelectedIndex[i]) {
        this.asyncSelectedIndex[i] = newIndex
      }
      if (i < 2) {
        if (i === 0) {
          const current = this.asyncData[newIndex]

          this.queryArea({
            province: current.value
          }).then(
            (resp) => {
              this.cityList = (resp.data || []).map(item => {
                return {
                  text: item.name,
                  value: item.city
                }
              })
              this.queryArea({
                province: current.value,
                city: this.cityList[0].value
              }).then(
                (resp) => {
                  this.areaList = (resp.data || []).map(item => {
                    return {
                      text: item.name,
                      value: item.city
                    }
                  })
                  this.asyncSelectedIndex[1] = 0
                  this.asyncSelectedIndex[2] = 0
                  this.asyncData = this.provinceList.map(item => {
                    return {
                      ...item,
                      children: this.cityList.map(city => {
                        return {
                          ...city,
                          children: this.areaList
                        }
                      })
                    }
                  })
                  this.asyncPicker.setData(this.asyncData, this.asyncSelectedIndex)
                }
              )
            }
          )
        }
        
        if (i === 1) {
          const current = this.asyncData[this.asyncSelectedIndex[0]].children[newIndex]
          this.queryArea({
                province: this.asyncData[this.asyncSelectedIndex[0]].value,
                city: current.value
              }).then(
                (resp) => {
                  this.areaList = (resp.data || []).map(item => {
                    return {
                      text: item.name,
                      value: item.city
                    }
                  })
                  this.asyncSelectedIndex[2] = 0
                  this.asyncData = this.provinceList.map(item => {
                    return {
                      ...item,
                      children: this.cityList.map(city => {
                        return {
                          ...city,
                          children: this.areaList
                        }
                      })
                    }
                  })
                  this.asyncPicker.setData(this.asyncData, this.asyncSelectedIndex)
                }
              )
        }
        // Mock async load.
      }
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      const value = {
        province: {
          code: selectedVal[0],
          name: selectedText[0]
        },
        city: {
          code: selectedVal[1],
          name: selectedText[1]
        },
        area: {
          code: selectedVal[2],
          name: selectedText[2]
        }
      }
      this.$emit('change', value)
    },
    cancelHandle(e) {
      const value = {
        province: {
          code: '',
          name: ''
        },
        city: {
          code: '',
          name: ''
        },
        area: {
          code: '',
          name: ''
        }
      }
      this.$emit('change', value)
      this.visiable = false
    },
    closePicker() {
      this.asyncPicker.hide()
      this.visiable = false
    },
    queryArea(params) {
      return new Promise((resolve, reject) => {
        const request = { ...apis.COMPONENT.QUERY_AREA }
        request.params = params
        this.$request(request)
        .asyncThen(
          (resp) => {
            resolve(resp)
          },
          (error) => {
            reject(error)
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          reject(error)
          console.error(error)
        })
      })
    }
  }
}
</script>

<style lang="scss">
.x-area {
  .x-area-mask {
    display: none;
    &.x-area-mask-show {
      display: block;
      position: fixed;
      height: calc(100vh - 19.5rem);
      width: 100vw;
      top: 0;
      z-index: 101;
      // background-color: #25262d;
      // opacity: 0.4;
    }
  }
}

</style>